"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigData = exports.setAccessToken = exports.setRestConfig = void 0;
const elements_core_di_1 = require("@hydrogen/elements.core.di");
const restConfigData = {
    withBearerApplicationAccessToken: false,
    isVersionIncluded: false,
    headers: {},
    GATEWAY_API_URL: '',
    SERVICES_URL_SUFFIX: '',
    DMS_URL_SUFFIX: '',
    CUSTOM_URL_SUFFIX: '',
    ENGAGEMENT_CONTENT_URL_SUFFIX: '',
    CLIENT_SERVICE_URL_SUFFIX: '',
    FIDENTITY_URL_SUFFIX: '',
    CLIENT_SERVICE_MEMBER_URL_SUFFIX: '',
    CLIENT_SERVICE_HEADERS: {},
};
elements_core_di_1.container.bind('SetupData').toConstantValue(restConfigData);
const setRestConfig = (RestConfigs) => {
    const newConfig = Object.assign(Object.assign({}, (0, exports.getConfigData)()), RestConfigs);
    elements_core_di_1.container.rebind('SetupData').toConstantValue(newConfig);
};
exports.setRestConfig = setRestConfig;
const setAccessToken = (token) => {
    const configDataWHeaders = Object.assign(Object.assign({}, (0, exports.getConfigData)()), { headers: Object.assign(Object.assign({}, (0, exports.getConfigData)().headers), { Authorization: `Bearer ${token}` }) });
    elements_core_di_1.container.rebind('SetupData').toConstantValue(configDataWHeaders);
};
exports.setAccessToken = setAccessToken;
const getConfigData = () => elements_core_di_1.container.get('SetupData');
exports.getConfigData = getConfigData;
//# sourceMappingURL=config.js.map